<template>
  <!-- The app's status pill (AppStatusPill): a 5px dot in the tone colour and medium text on the
       tone's fill. `then` lists later states ({ text, tone, at }); each one rises at its `at`
       while the one before it goes, and the last is the resting (final) frame. -->
  <span class="mp fm-stack">
    <span
      v-for="(state, index) in states"
      :key="state.text"
      :class="{ 'fm-out': index < states.length - 1 }"
      :style="index < states.length - 1 ? { '--at': states[index + 1].at } : null"
    >
      <span class="mp-pill" :class="[`mp-${state.tone || 'gray'}`, { 'fm-rise': index > 0 }]" :style="index > 0 ? { '--at': state.at, '--len': 0.08 } : null">
        <i />{{ state.text }}
      </span>
    </span>
  </span>
</template>

<script setup>
const props = defineProps({
  pill: { type: Object, required: true },
  then: { type: Array, default: () => [] },
});

const states = computed(() => [props.pill, ...props.then]);
</script>

<style>
.mp { flex: none; justify-items: end; }
.mp-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 20px;
  border-radius: 999px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}
.mp-pill i { width: 5px; height: 5px; border-radius: 999px; background: currentColor; }
.mp-gray { background: var(--fm-gray-fill); color: var(--fm-gray); }
.mp-green { background: var(--fm-green-fill); color: var(--fm-green); }
.mp-blue { background: var(--fm-blue-fill); color: var(--fm-blue); }
.mp-red { background: var(--fm-red-fill); color: var(--fm-red); }
.mp-orange { background: var(--fm-orange-fill); color: var(--fm-orange); }
.mp-amber { background: var(--fm-amber-fill); color: var(--fm-amber); }
.mp-purple { background: var(--fm-purple-fill); color: var(--fm-purple); }
</style>
